'use strict';

/*global isEmpty*/
/*global services*/

(function ($) {
    var $btn = null;

    var methods = {
        init: function (/*options*/) {
            return this.each(function () {
                var _this = this;
                var $this = $(this);

                if ($this.hasClass('gdpr-agreem-init')) {
                    return;
                }

                $this.addClass('gdpr-agreem-init');

                $this.on('change', '.gdpr-required :radio', function (e) {
                    methods.change.apply(_this, [$(this).closest('.gdpr-required')]);
                    return false;
                });
            });
        },

        change: function ($agreem) {
            var _this = this;

            if($agreem.find(':radio:checked').val() === 'NO') {
                var confirm = services.get('confirm');
                confirm.open({
                    width: 'md',
                    title: services.get('translator').trans('GDPR_RemoveAgreem'),
                    content: services.get('translator').trans('GDPR_RemoveAgreemDescription'),
                    confirmBtnTitle: services.get('translator').trans('GDPR_RemoveAgreemCancel'),
                    rejectBtnTitle: services.get('translator').trans('GDPR_RemoveAgreemContinue'),
                    rejectCallback: function () {
                        methods.reject.apply(_this, [$agreem]);
                    },
                    confirmCallback: function () {
                        methods.confirm.apply(_this, [$agreem]);
                    }
                });
            }

            return _this;
        },

        reject: function (/*$agreem*/) {
            var confirm = services.get('confirm');
            confirm.close();
        },

        confirm: function ($agreem) {
            $agreem.find('[value="YES"]').click();

            var confirm = services.get('confirm');
            confirm.close();
        }
    };

    $.fn.gdprAgreem = function (methodOrOptions) {
        if (methods[methodOrOptions]) {
            return methods[methodOrOptions].apply(this, Array.prototype.slice.call(arguments, 1));
        } else if (typeof methodOrOptions === 'object' || !methodOrOptions) {
            return methods.init.apply(this, arguments);
        } else {
            $.error('Method ' + methodOrOptions + ' does not exists on jQuery.gdprAgreem');
        }
    };

    $.fn.gdprAgreem.defaults = {};
})(jQuery);
